import { createAction } from "@reduxjs/toolkit";

import type { ApplicationScope } from "@superblocksteam/shared";

import type { EditorOpenTabType } from "legacy/constants/EditorPreferencesConstants";

type FocusedItem = {
  type: string;
  name: string;
  id: string;
  scope: ApplicationScope;
};

type OpenTabPayload = {
  entityId: string;
  tabType: EditorOpenTabType;
  property?: string;
  actionId?: string | "input" | "response";
  // if true, we check for the existence of the property before opening the tab
  strict?: boolean;
};

export const openEditorTab = createAction<OpenTabPayload>("OPEN_EDITOR_TAB");

export const setEditorHeight = createAction(
  "SET_EDITOR_HEIGHT",
  (height: number) => ({ payload: { height } }),
);

export const updateApplicationSidebarKey = createAction<{
  selectedKey: string | undefined;
  focusedItems?: FocusedItem[];
  expandedStateItems?: { name: string; scope: ApplicationScope }[];
}>("UPDATE_APPLICATION_SIDEBAR_KEY");

export const updateWorkflowSidebarKey = createAction<{
  selectedKey: string | undefined;
}>("UPDATE_WORKFLOW_SIDEBAR_KEY");
